import { Game } from './core/Game';

const canvas = document.getElementById('game-canvas') as HTMLCanvasElement;

canvas.addEventListener('contextmenu', (e) => e.preventDefault());

const game = new Game(canvas);
void game.start().then(() => {
  // 自動テスト / デバッグ用フック
  (window as unknown as { __roomEscape?: unknown }).__roomEscape = game.getDebugApi();
});

// プレイ中のみポインタロック（UI 操作を阻害しない）
canvas.addEventListener('click', () => {
  const title = document.getElementById('screen-title');
  const pause = document.getElementById('screen-pause');
  const examine = document.getElementById('examine');
  const settings = document.getElementById('screen-settings');
  const clear = document.getElementById('screen-clear');
  const loading = document.getElementById('screen-loading');
  const uiOpen =
    !title?.classList.contains('hidden') ||
    !pause?.classList.contains('hidden') ||
    !examine?.classList.contains('hidden') ||
    !settings?.classList.contains('hidden') ||
    !clear?.classList.contains('hidden') ||
    !loading?.classList.contains('hidden');
  if (uiOpen) return;
  if (document.pointerLockElement !== canvas) {
    canvas.requestPointerLock?.();
  }
});
